/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Degraded_Last_Sync_IncompleteInputs */



/**
* | output |
* | --- |
* | "The last sync finished, but part of the content could not be fetched." |
*
* @param {Sync_Degraded_Last_Sync_IncompleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_degraded_last_sync_incomplete = /** @type {((inputs?: Sync_Degraded_Last_Sync_IncompleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Degraded_Last_Sync_IncompleteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die letzte Synchronisierung ist durchgelaufen, aber ein Teil der Inhalte konnte nicht geholt werden.")
	return /** @type {LocalizedString} */ ("The last sync finished, but part of the content could not be fetched.")
});